export enum ReportFormats {
  PDF = "PDF",
  DYNAMIC_FEEDBACK = "VideoFeedback",
  DYNAMIC_FEEDBACK_AI = "VideoFeedbackWithAI"
}
